import { Component, inject } from '@angular/core';
import { InputValidatorDirective } from '@common/directive/input-validator.directive';
import { PaginatorModule } from '@primeng/paginator';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { BasicForm } from '@shared/components/classes/basic.form';
import { UsersService } from '@modules/settings/users/users.service';
import urlJoin from 'url-join';
import { environment } from '@environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PasswordModule } from '@primeng/password';
import { ButtonModule } from '@primeng/button';
import Swal from 'sweetalert2';


@Component({
  selector: 'password-change',
  standalone: true,
  imports: [
    InputValidatorDirective,
    PaginatorModule,
    ReactiveFormsModule,
    TranslatePipe,
    PasswordModule,
    ButtonModule
  ],
  templateUrl: './password-change.component.html',
  styleUrl: './password-change.component.scss'
})
export class PasswordChangeComponent extends BasicForm<any> {
  _defaultService: UsersService = inject(UsersService);
  _http = inject(HttpClient);
  form: FormGroup;

  constructor(private fb: FormBuilder) {
    super();
    this.form = this.fb.group({
      currentPassword: [null, Validators.required],
      newPassword: [null, Validators.required],
      newPasswordConfirmation: [null, [Validators.required]]
    });
  }

  updatePassword(form: any) {
    return this._http.put(urlJoin(this.getUrl(), 'edit/password'), form)
  }

  getUrl(): string {
    return urlJoin(environment.apiUrl, 'users');
  }

  submitAction(data: object): Observable<any> {
    return this.updatePassword(data)
  }



}
